import { useLDClient } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";

import { IntegrationAbility } from "@/apollo/types";

export type FeatureMode = "show" | "hide" | "preview" | "beta";

export function useIntegrationFlagHelper() {
  const ldClient = useLDClient();

  return useMemo(() => {
    const mapTypeToFlagProp = (type: IntegrationAbility) => {
      switch (type) {
        case IntegrationAbility.EltSource: {
          return "elt";
        }
        case IntegrationAbility.ActivateDestination: {
          return "reverseElt";
        }
        default:
          return null;
      }
    };
    const checkFlag = (
      integrationId: string,
      type: IntegrationAbility,
    ): FeatureMode => {
      const flagValue = ldClient?.variation(integrationId, "show") ?? "show";
      if (typeof flagValue === "object") {
        const flagProp = mapTypeToFlagProp(type);
        return flagProp ? (flagValue[flagProp] ?? "show") : "show";
      } else return flagValue;
    };

    return {
      checkFlag,
    };
  }, [ldClient]);
}
